import MainLayout from "@/components/layout/MainLayout";
import TermsUpdated from "@/components/TermsUpdated";

const Terms = () => {
  return (
    <MainLayout>
      <div className="pt-24 md:pt-28">
        <TermsUpdated />
      </div>
    </MainLayout>
  );
};

export default Terms;
